
import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Svg, Path } from 'react-native-svg';

interface TimeFilterContentProps {
  onSelectionChange: (selectedTimes: string[]) => void;
  currentSelection: string[];
}

const timeOptions = [
  '00:00', '01:00', '02:00', '03:00', '04:00', '05:00', 
  '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', 
  '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', 
  '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'
];

export default function TimeFilterContent({ onSelectionChange, currentSelection }: TimeFilterContentProps) {
  const [selectedTime, setSelectedTime] = useState<string | null>(currentSelection[0] || null);

  const handleOptionPress = (time: string) => {
    const newSelection = selectedTime === time ? null : time;
    setSelectedTime(newSelection);
  };

  // Expose the current selection to parent for when "Aplicar" is pressed
  useEffect(() => {
    onSelectionChange(selectedTime ? [selectedTime] : []);
  }, [selectedTime, onSelectionChange]);

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <View style={styles.timeGrid}>
        {timeOptions.map((time) => (
          <TouchableOpacity
            key={time}
            style={[
              styles.optionCard,
              selectedTime === time && styles.selectedOptionCard
            ]}
            onPress={() => handleOptionPress(time)}
          >
            <Text style={styles.optionText}>
              {time}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: (68 * 5) + (8 * 4), // Exactly 5 rows height + gaps between them
  },
  timeGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    justifyContent: 'space-between',
  },
  optionCard: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#F9F8F3',
    width: '31%', // 3 columns with gaps
  },
  selectedOptionCard: {
    borderColor: '#004165',
    backgroundColor: '#E6EBF0',
  },
  optionText: {
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    color: '#151515',
    lineHeight: 19.6,
    textAlign: 'center',
  },
});
